const AboutPage = () => {
  return (
    <div className="info-page">
      <div className="info-page__header">
        <h1 className="info-page__title">About</h1>
        <p className="info-page__subtitle">The story behind milligram.tv</p>
      </div>

      <div className="info-page__sections">
        <section className="info-page__section">
          <h3>Mission</h3>
          <p>
            milligram.tv is a decentralized exchange built to make gold trading accessible
            to everyone. By tokenizing gold down to the milligram, we enable fractional
            ownership of the world's oldest store of value &mdash; secured by Ethereum's
            battle-tested blockchain.
          </p>
        </section>

        <section className="info-page__section">
          <h3>Why Gold on Ethereum?</h3>
          <p>
            Gold has been trusted for thousands of years. Ethereum provides trustless,
            permissionless infrastructure. Together they offer self-custodial gold trading
            without intermediaries, banks, or geographic limitations. Trade gold from
            anywhere, at any time.
          </p>
        </section>

        <section className="info-page__section">
          <h3>The MG Token</h3>
          <p>
            One MG represents one milligram of gold. At 31,103.5 milligrams per troy ounce,
            1 PAXG (1 troy ounce of gold) converts to exactly 31,103.5 MG. This granular
            denomination makes gold practical for everyday transactions and micro-trades.
          </p>
        </section>

        <section className="info-page__section">
          <h3>MGTV Governance</h3>
          <p>
            MGTV is the governance token of the milligram.tv ecosystem. Holders enjoy a 10x
            fee discount on Gold Vault operations (0.369% vs 3.69%). MGTV tokens are burned
            on discounted transactions, creating a deflationary mechanism aligned with
            platform usage.
          </p>
        </section>
      </div>
    </div>
  )
}

export default AboutPage
